"use client"

import { ErrorDisplay } from "@repo/ui"

interface ErrorProps {
	error: Error & { digest?: string }
	// reset: () => void
}

export default function Error({ error }: ErrorProps) {
	return <ErrorDisplay error={error} />
}
